// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___AjifR","content_root":"style-module__content_root___kOVbC"};
    if(module.hot) {
      // 1697460472431
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  